var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 14.048H14C14.2733 14.048 14.5 13.8213 14.5 13.548C14.5 13.2747 14.2733 13.048 14 13.048H5.99933C4.25267 13.048 3.38 13.048 2.94 12.608C2.5 12.168 2.5 11.2947 2.5 9.54801V2.88135C2.5 2.60801 2.27333 2.38135 2 2.38135C1.72667 2.38135 1.5 2.60801 1.5 2.88135V9.54801C1.5 11.568 1.5 12.5813 2.23333 13.3147C2.96667 14.048 3.98 14.048 5.99933 14.048H6ZM3.64667 9.90135C3.74667 10.0013 3.87333 10.048 4 10.048C4.12667 10.048 4.25333 10.0013 4.35333 9.90135L6.52 7.73468C6.84 7.41468 7.07333 7.18135 7.2 7.14801C7.28667 7.12135 7.37333 7.12135 7.47333 7.14801C7.59333 7.18135 7.82667 7.41468 8.14667 7.73468C8.62667 8.21468 8.88667 8.47468 9.25333 8.57468C9.52667 8.65468 9.81333 8.65468 10.0733 8.57468C10.4467 8.47468 10.7067 8.21468 11.1867 7.73468L13.6867 5.23468C13.88 5.04135 13.88 4.72135 13.6867 4.52801C13.5926 4.43503 13.4656 4.38288 13.3333 4.38288C13.201 4.38288 13.0741 4.43503 12.98 4.52801L10.48 7.02801L10.4787 7.02868C10.1587 7.34868 9.926 7.58201 9.79933 7.61535C9.71267 7.64201 9.626 7.64201 9.526 7.61535C9.406 7.58201 9.17333 7.34868 8.854 7.02868H8.85267C8.37267 6.54868 8.11267 6.28868 7.746 6.18868C7.47267 6.10868 7.186 6.10868 6.926 6.18868C6.55267 6.28868 6.29267 6.54868 5.81267 7.02868L3.646 9.19535C3.45267 9.38868 3.45267 9.70868 3.646 9.90201",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.004429730e7529e157bdb349a5ac3703.svg";
export { ForwardRef as ReactComponent };